/**
 * WordPress dependencies
 */
import { useState, useEffect } from '@wordpress/element';

/**
 * Internal dependencies
 */
import Header from './Header';
import BookingList from './BookingList';
import EditBookingForm from './EditBookingForm';
import CreateBookingForm from './CreateBookingForm';

const BookingsApp = () => {
	const [ currentRoute, setCurrentRoute ] = useState( '' );
	const [ bookingId, setBookingId ] = useState( null );

	// Parse hash route
	const parseRoute = () => {
		const hash = window.location.hash.slice( 1 ); // Remove #

		if ( ! hash || hash === '/' || hash === '/bookings' ) {
			return {
				route: 'list',
				id: null,
			};
		}

		// Match /bookings/create pattern
		if ( hash === '/bookings/create' ) {
			return {
				route: 'create',
				id: null,
			};
		}

		// Match /bookings/123 pattern
		const editMatch = hash.match( /^\/bookings\/(\d+)$/ );
		if ( editMatch ) {
			return {
				route: 'edit',
				id: parseInt( editMatch[ 1 ] ),
			};
		}

		// Default to list for unknown routes
		return {
			route: 'list',
			id: null,
		};
	};

	// Update route state when hash changes
	useEffect( () => {
		const handleHashChange = () => {
			const { route, id } = parseRoute();
			setCurrentRoute( route );
			setBookingId( id );
		};

		// Set initial route
		handleHashChange();

		// Listen for hash changes
		window.addEventListener( 'hashchange', handleHashChange );
		return () => {
			window.removeEventListener( 'hashchange', handleHashChange );
		};
	}, [] );

	// Navigation functions
	const navigateToList = () => {
		window.location.hash = '#/bookings';
	};

	const navigateToCreate = () => {
		window.location.hash = '#/bookings/create';
	};

	const navigateToEdit = ( id ) => {
		window.location.hash = `#/bookings/${ id }`;
	};

	// Handle successful edit
	const handleBookingUpdated = ( booking ) => {
		// Redirect to list with success state
		navigateToList();
		// TODO: Add success toast notification
	};

	// Handle successful creation
	const handleBookingCreated = ( booking ) => {
		// Redirect to list with success state
		navigateToList();
		// TODO: Add success toast notification
	};

	// Render current view
	const renderCurrentView = () => {
		switch ( currentRoute ) {
			case 'create':
				return (
					<CreateBookingForm
						onSave={ handleBookingCreated }
						onCancel={ navigateToList }
					/>
				);
			case 'edit':
				return (
					<EditBookingForm
						bookingId={ bookingId }
						onSave={ handleBookingUpdated }
						onCancel={ navigateToList }
					/>
				);
			case 'list':
			default:
				return (
					<BookingList
						onEditBooking={ navigateToEdit }
						onCreateNew={ navigateToCreate }
					/>
				);
		}
	};

	return (
		<div className="nb-bookings-app">
			<Header
				version={ nemtlyBookingAdmin?.version || '' }
				pageName="Bookings"
			/>
			{ renderCurrentView() }
		</div>
	);
};

export default BookingsApp;
